import './instrument';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MatomoTracker } from '@/shared/components/MatomoTracker'
import './index.css'
import { bootstrapPublicLoginLanguage } from '@/shared/lib/language-preferences'

async function start() {
  await bootstrapPublicLoginLanguage();
  await import('./i18n')
  const { default: App } = await import('./App.tsx')

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <MatomoTracker />
        <App />
      </BrowserRouter>
    </StrictMode>,
  )
}

void start()
